import { api } from 'api'

export type CompaniesResponse = {
  companies: {
    id: number
    name: string
  }[]
}

export async function getCompanies(excludeNonGroupCompanies?: boolean) {
  const response = await api.get<CompaniesResponse>(
    '/company/actor/companies',
    {
      params: {
        exclude_non_group_companies: excludeNonGroupCompanies,
      },
    }
  )

  return response.data.companies
}
